import { render, staticRenderFns } from "./JCenterCol.vue?vue&type=template&id=47f76882"
import script from "./JCenterCol.vue?vue&type=script&lang=ts"
export * from "./JCenterCol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports